import React, { useState } from 'react';
// import './style.scss'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import CompanyBid from "../../components/CompanyBid";
import CompanyEmployers from "../../components/CompanyEmployers";
import { NavLinkTab } from '../../components/core/Tabs/StatelessTabs';
import PersonalCabinet from "../PersonalCabinet";
import OrgChartPage, { UserCreateModal } from "../Tree";
import { CopyLinkIcon, CopyLinkIcon1, MenuNavPeoplesIcon, SfFilterCopyIcon } from '../../components/Public/markup/icons';
import useClickPast from '../../hooks/useClickPast';
import useModalWithData from '../../hooks/useModalWithData';
import PanModal from '../../components/core/PanModal';
import useApi from '../../hooks/useApi';
import { useModal } from 'react-modal-hook';
import Loader from '../../components/Loader';
import CopyToClipboard from 'react-copy-to-clipboard';
import { successToast } from '../../components/toasts';
import Button from '../../components/core/Button';
import useCompanyRole from '../../hooks/useCompanyRole';

const CabinetCompany = () => {

  const [openCreateUser, closeModal] = useModal(({ in: open, onExited }) => (<PanModal customClass="tree-modal" isSmall title={'Добавить сотрудника'} closeModal={closeModal}>
    <UserCreateModal closeModal={closeModal} />
  </PanModal>))

  const [openRegisterByLink, closeRegisterByLinkModal] = useModal(({ in: open, onExited }) => (<PanModal customClass="tree-modal" isSmall title={'Регистрация по ссылке'} closeModal={closeRegisterByLinkModal}>
    <AddUserByLinkModal />
  </PanModal>))

  const showLinks = !useCompanyRole(["full_access_departament"])

  const { data: { count }} = useApi({
    payload: ["panpartner:company.ajax", "getCountConfirmations",]
  })

  return (
    <div className="wrapper">
      <h3 className="h3 sf__h1 with-tg-link" style={{ marginBottom: 11 }}>
        <p>{showLinks ? "Компания" : "Сотрудники"}</p>
      </h3>
      <PersonalCabinet />

      {showLinks && <div style={{ marginBottom: 10, display: "flex" }}>
        <NavLinkTab label="Структура компании" linkProps={{ to: "/personalcabinet/structure" }} />
        <NavLinkTab label="Сотрудники" linkProps={{ to: "/personalcabinet/employees" }} />
        <NavLinkTab label="Заявки" linkProps={{ to: "/personalcabinet/requests" }}  count={count}/>
        <AddEmployeeButton openCreateUser={openCreateUser} openRegisterByLink={openRegisterByLink} />
      </div>}
      {!showLinks && <div style={{ marginBottom: 10, display: "flex" }}>
        <AddEmployeeButton openCreateUser={openCreateUser} openRegisterByLink={openRegisterByLink} />
      </div>}
      <Switch>
        <Route exact path={"/personalcabinet/structure"} render={() => showLinks ? <OrgChartPage /> : <Redirect to="/personalcabinet/employees" />} />
        <Route exact path={"/personalcabinet/employees"} render={() => <CompanyEmployers />} />
        <Route exact path={"/personalcabinet/requests"} render={() => showLinks ? <CompanyBid /> : <Redirect to="/personalcabinet/employees" />} />
      </Switch>

    </div>
  )
}
const AddUserByLinkModal = () => {

  const { data: { link_quick_registration, id }, isLoading, dataSetter, isRefreshing, refresher } = useApi({
    payload: ["panpartner:registration.ajax", "getQuickRegistrationLink",]
  })

  const companyRegisterLink = link_quick_registration || `${window.location.hostname}/register/new`

  return <div style={{
    display: "flex",
    flexDirection: "column"
  }}>
    <div style={{
      display: "flex",
      justifyContent: "space-between",
      padding: "16px 12px",
      border: "1px solid #DFE1E9",
      borderRadius: 5,
      color: "#777A89",
      alignItems: "center",


    }}>
      {isLoading || isRefreshing ? <Loader /> : <span
        style={{
          textWrap: "nowrap",
          overflow: "hidden"
        }}
      >{companyRegisterLink}</span>}
      <CopyToClipboard text={companyRegisterLink} onCopy={() => successToast(<div>Ссылка скопирована в буфер обмена</div>)}>
        <Button buttonType="clean"><CopyLinkIcon1 /></Button>
      </CopyToClipboard>

    </div>
    <div
      onClick={() => refresher(["panpartner:registration.ajax", "updateQuickRegistrationLink", { id }])}
      style={{
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        color: "#ff2d23",
        cursor: "pointer",
        margin: "20px auto"
      }}
    >
      <SfFilterCopyIcon color='#ff2d23' /> &nbsp; Обновить ссылку
    </div>
  </div>
}
const AddEmployeeButton = ({ openCreateUser, openRegisterByLink }) => {
  const [isActive, setIsActive] = useState(false)
  const node = useClickPast(() => { setIsActive(false) });

  return (
    <div style={{ margin: "10px 0 0 auto" }}>
      <span

        onClick={() => { setIsActive(prev => !prev) }}
        style={{ display: "flex", alignItems: "center", color: "#ff2d23", cursor: "pointer" }}
      >
        +
        <MenuNavPeoplesIcon color='#ff2d23' />
        &nbsp;
        Добавить сотрудника
      </span>
      <ul className={`crm-table__sf-controls`}
        ref={node}
        onClick={() => { setIsActive(!isActive) }}
        style={{ display: isActive ? "flex" : "none", flexDirection: "column" }}

      >
        <li onClick={openRegisterByLink} style={{ cursor: 'pointer' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.6582 7.45712L13.2095 5.90787C13.8658 5.30659 14.7292 4.98163 15.6197 5.0008C16.5101 5.01998 17.3587 5.3818 17.9884 6.01077C18.6181 6.63974 18.9802 7.48726 18.9992 8.37646C19.0182 9.26566 18.6926 10.1278 18.0904 10.7831L15.8735 12.9896C15.5546 13.3092 15.1758 13.5629 14.7587 13.7362C14.3416 13.9096 13.8944 13.9992 13.4427 14C12.9909 14.0008 12.5434 13.9127 12.1257 13.7407C11.708 13.5688 11.3284 13.3164 11.0084 12.9979L11 12.9896" stroke="#2C2E3E" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.3414 16.5468L10.7888 18.097C10.1318 18.6961 9.26863 19.0192 8.37903 18.9991C7.48942 18.979 6.64185 18.6171 6.01264 17.9889C5.38344 17.3606 5.02106 16.5143 5.00089 15.626C4.98072 14.7378 5.30433 13.8759 5.90437 13.2198L8.12287 11.012C8.44187 10.692 8.82088 10.438 9.23825 10.2643C9.65561 10.0907 10.1032 10.0009 10.5553 10C11.0074 9.99913 11.4553 10.0872 11.8734 10.2593C12.2914 10.4313 12.6714 10.6839 12.9916 11.0026L13 11.012" stroke="#2C2E3E" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Регистрация по ссылке
        </li>
        <li onClick={openCreateUser} style={{ cursor: 'pointer' }}>
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5.84839V12.9195H19.0711" stroke="#2C2E3E" stroke-linecap="round" />
            <path d="M4.92896 12.9194H12V19.9905" stroke="#2C2E3E" stroke-linecap="round" />
          </svg>
          <span>Добавить вручную</span>
        </li>

      </ul>
    </div>
  )
}

export default CabinetCompany
